import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Container } from "react-bootstrap";
import { ArrowLeft, ArrowUp } from "react-bootstrap-icons";
import resourcesList from "./resourcesList";
import FadeWrapper from "../FadeWrapper";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ResourcesTableOfContents from "./ResourcesTableOfContents";
import ReadTime from "./ReadTime";
import CategorySpans from "./CategorySpans";

export default function ArticlePage() {
  const { id } = useParams();
  const resource = useMemo(
    () => resourcesList.find((r) => r.href === id),
    [id]
  );
  const Article = resource?.mainPageContent || null;

  const [showScrollTop, setShowScrollTop] = useState(false)

  const contentRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) setShowScrollTop(true);
      else setShowScrollTop(false);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!resource || !Article) return <p className="p-4">404 — Article Not Found</p>;

  return (
    <>
      {/* scroll top top button at bottom right */}
      {showScrollTop && (
        <div
          style={{
            position: "fixed",
            bottom: 50,
            right: 40,
          }}
        >
          <Button
            onClick={scrollToTop}
            variant="light"
            className="shadow-sm d-flex align-items-center justify-content-center"
            style={{
              borderRadius: "50%",
              width: 48,
              height: 48,
              backgroundColor: "#1d446b",
            }}
          >
            <ArrowUp size={20} />
          </Button>
        </div>
      )}

      {/* article header , title + read time + date */}
      <div
        className="text-white text-center justify-content-center py-5"
        style={{
          background: "#1d446b",
          minHeight: 160,
        }}
      >
        <CategorySpans categories={[resource.category]} />
        <h1 className="fw-bold fs-2">{resource.title}</h1>
        <br />
        <ReadTime variant="badge" amount={resource.readTime} />
      </div>


      <Container className="py-5" style={{ maxWidth: 1200 }}>
        <Row>
          <Col sm={3}>
            <div className="sticky-top sticky-top-offset">
              <Button variant="outline-primary" className="mb-4" href="/resources">
                <ArrowLeft className="me-1" /> Back to resources
              </Button>

              <ResourcesTableOfContents articleDep={Article} contentRef={contentRef} />
            </div>
          </Col>
          <Col>
            <FadeWrapper>
              <div ref={contentRef} className="article-content">
                <Article />
              </div>
            </FadeWrapper>
          </Col>
        </Row>
      </Container>

      {/* styles */}
      <style>{`
        .article-content {
          font-size: 1.05rem;
          line-height: 1.8;
          color: #212529;
        }
        .article-content h2 {
          margin-top: 2.25rem;
          margin-bottom: 1rem;
          font-weight: 700;
        }
        .article-content h3 {
          margin-top: 1.75rem;
          margin-bottom: 0.75rem;
          font-weight: 600;
        }
        .article-content p { margin-bottom: 1.1rem; }
        .article-content img {
          display: block;
          max-width: 100%;
          height: auto;
          margin: 1.25rem auto;
          border-radius: 0.5rem;
        }
      `}</style>
    </>
  );
}
